export function capitalizeEachWord(str: string) {
  if (typeof str !== "string" || str.length === 0) {
    return ""; // Handle empty or non-string inputs
  }
  return str
    .toLowerCase() // Convert the entire string to lowercase first
    .split(" ") // Split the string into words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(" "); // Join the words back into a single string
}

// 常见的二级域名，获取主域名的时候要特殊处理。参照：https://joyspace.jd.com/pages/3sKosLLoSQOQek3r7vES
const secondDomainList = [
  '.co.de',
  '.co.nl',
  '.co.uk',
  '.co.it',
  '.co.dk',
  '.co.jp',
  '.co.kr',
  '.co.id',
  '.co.th',
  '.co.in',
  '.com.au'
];
export function getMainDomainFromHost(host: string) {
// 去除端口号部分
const domainWithoutPort = host.split(":")[0];

let sliceNum = -2;
if (secondDomainList.some((sd) => domainWithoutPort.endsWith(sd))) {
  sliceNum = -3;
}

const mainDomain = domainWithoutPort.split(".").slice(sliceNum).join(".");
return mainDomain;
}

